import { createSlice } from "@reduxjs/toolkit";

interface Props {
  billerCategories: any;
  billers: any;
  isFetchingBillerInfo: boolean;
};

const initialState: Props = {
  billerCategories: [],
  billers: [],
  isFetchingBillerInfo: false
};

export const payBillSlice = createSlice({
  name: "payBillStore",
  initialState,
  reducers: {
    fetchBillerCategories: (state, action) => {

    },
    fetchBillerCategoriesSuccess: (state, action) => {
      state.billerCategories = action.payload;
    },
    fetchBillerCategoriesFailed: (state, action) => {

    },
    fetchBillers: (state, action) => {
    },
    fetchBillersSuccess: (state, action) => {
      state.billers = action.payload;
    },
    fetchBillersFailed: (state, action) => {

    },
    fetchSearchedBillers: (state, action) => {
    },
    fetchBillerInfo: (state, action) => {
    },
    fetchBillerInfoV2: (state, action) => {
      state.isFetchingBillerInfo = true;
    },
    fetchBillerInfoV2Success: (state, action) => {
      state.isFetchingBillerInfo = false;
    },
    fetchBillerInfoV2Failure: (state, action) => {
      state.isFetchingBillerInfo = false;
    },
    fetchBillerInfoSuccess: (state, action) => {
    },
    customerLookup: (state, action) => {
    },
    customerLookupSuccess: (state, action) => {
    },
    customerLookupFailed: (state, action) => {
    },
    payBillProcessTrxn: (state, action) => {
    },
    payBillProcessTrxnSuccess: (state, action) => {
    },
    payBillProcessTrxnFailed: (state, action) => {
    },
  }
});

export const {
  fetchBillerCategories,
  fetchBillerCategoriesSuccess,
  fetchBillerCategoriesFailed,
  fetchBillers,
  fetchBillersSuccess,
  fetchBillersFailed,
  fetchSearchedBillers,
  fetchBillerInfo,
  fetchBillerInfoV2,
  fetchBillerInfoV2Failure,
  fetchBillerInfoV2Success,
  fetchBillerInfoSuccess,
  customerLookup,
  customerLookupSuccess,
  customerLookupFailed,
  payBillProcessTrxn,
  payBillProcessTrxnSuccess,
  payBillProcessTrxnFailed
} = payBillSlice.actions;

export default payBillSlice.reducer;